import { Component, Injector, TemplateRef } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ModalBottomsheetType } from './modal-bottomsheet.helper';

@Component({
  selector: 'planone-modal-bottomsheet',
  templateUrl: './modal-bottomsheet.component.html',
  styleUrls: ['./modal-bottomsheet.component.scss'],
})
export class ModalBottomsheetComponent {
  url: string | undefined = undefined;
  data?: {
    type: ModalBottomsheetType;
    content: TemplateRef<never> | null;
    title: TemplateRef<never> | null;
    size: string | undefined;
    actions: TemplateRef<never> | null;
    [key: string]: any;
  };
  context: { [key: string]: any };

  constructor(injector: Injector, private bottomSheet: MatBottomSheet) {
    try {
      this.data = injector.get(MAT_DIALOG_DATA);
    } catch (error) {
      this.data = injector.get(MAT_BOTTOM_SHEET_DATA);
    }

    this.context = {
      ...this.data,
      type: undefined,
      content: undefined,
      title: undefined,
      size: undefined,
      actions: undefined,
    };
  }

  dismiss() {
    const bottomSheetRef = this.bottomSheet._openedBottomSheetRef;

    if (bottomSheetRef) {
      bottomSheetRef.dismiss();
    }
  }
}
